export default "__VITE_ASSET__Bzf9dnMs__"